import { css } from '@inter-ikea-kompis/web-component';

import type IAssistanceCardStyleOptions from '../../types/IAssistanceCardStyleOptions.js';

export default class AssistanceCardStyle {
	public static getStyle(options: IAssistanceCardStyleOptions): string {
		const { spacing, color } = options.theme;

		// Using small as breakpoint since fontStyle is the same for all of theme
		const { headingXSmall, bodyMedium } = options.theme.breakpoint.small.fontStyle;
		return css`
			:host {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				gap: ${spacing.space100 / 16}rem;
			}

			skapa-icon {
				color: ${color.text.dark};
				flex-shrink: 0;
			}

			h3 {
				font-weight: ${headingXSmall.weight ?? ''};
				font-size: ${headingXSmall.size / 16}rem;
				line-height: ${headingXSmall.lineHeight / 16}rem;
				color: ${color.neutral.grey900};
				margin: 0;
			}

			p {
				color: ${color.neutral.grey700};
				margin: 0;
			}

			p,
			a,
			div {
				line-height: ${bodyMedium.lineHeight / 16}rem;
				font-size: ${bodyMedium.size / 16}rem;
			}

			.body {
				margin: ${spacing.space25 / 16}rem 0 0 0;
			}

			a {
				display: inline;
				overflow: overlay;
			}

			.hint,
			.link-wrapper {
				margin: ${spacing.space100 / 16}rem 0 0 0;
			}

			*,
			*:before,
			*:after {
				outline: none;
			}
		`;
	}
}
